import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import RoleRoute from '@BUP/routes/RoleRoute'
import { LogbookPage } from '@BUP/pages/logbook'
import { LogbookShowComplaintPage } from '@BUP/pages/logbook/complaints/show'
import { LogbookNewComplaintPage } from '@BUP/pages/logbook/complaints/new'
import { LogbookShowComplaintEntryPage } from '@BUP/pages/logbook/complaints/entries/show'

const LogbookNavigation = () => {
  return (
    <Routes>
      <Route
        path='complaints/new'
        element={
          <RoleRoute name='LogbookNewComplaintPage'>
            <LogbookNewComplaintPage />
          </RoleRoute>
        }
      />
      <Route
        path='complaints/:complaintId/entries/:complaintEntryId'
        element={
          <RoleRoute name='LogbookShowComplaintEntryPage'>
            <LogbookShowComplaintEntryPage />
          </RoleRoute>
        }
      />
      <Route
        path='complaints/:complaintId'
        element={
          <RoleRoute name='LogbookShowComplaintPage'>
            <LogbookShowComplaintPage />
          </RoleRoute>
        }
      />
      <Route
        path='/'
        element={
          <RoleRoute name='LogbookPage'>
            <LogbookPage />
          </RoleRoute>
        }
      />
      <Route
        path='*'
        element={<Navigate to='/' />}
      />
    </Routes>
  )
}

export default LogbookNavigation
